import MonoText from "components/MonoText"
import MoneyDisplay from "components/MoneyDisplay"
import React from "react";

export default ({model}) => {
  if (model.item_quantity) {
    return (
    <MonoText>{model.item_quantity} {model.item_label}</MonoText>
    )
  } else {
    return (
      <MonoText><MoneyDisplay amount={model.price} currency={model.price_currency} /></MonoText>
    )
  }
}